import { useCallback } from 'react'

import { TreeNodeOrNodeSlug } from 'react-common'
import { useAppDispatch, useAppSelector } from '@/store/hooks'

import { setSidebarLayers } from '@/store/slices/layoutSlice'

export function useSidebarLayers() {
  const dispatch = useAppDispatch()
  const { sidebarLayers } = useAppSelector((state) => state.layout)

  const setLayers = useCallback(
    (layers: TreeNodeOrNodeSlug[] | null) => {
      dispatch(setSidebarLayers(layers))
    },
    [dispatch],
  )

  return {
    sidebarLayers,
    setLayers,
  }
}
